import { ClockIcon } from '@heroicons/react/24/outline'

const ComingSoon = () => (
	<div className='hx-comingsoon'>
		<div className='hx-comingsoon__icon'>
			<ClockIcon style={{ width: 24, height: 24 }} aria-hidden='true' />
		</div>

		<div>
			<h3>Biljettsläpp snart</h3>
			<p>Biljetter till Harmoni Expo den 24–25 oktober släpps inom kort.</p>
			<p>I år firar vi 30 år och mer information om höstjubileet presenteras snart.</p>
		</div>

		<div className='hx-comingsoon__divider'>
			<h3>Tickets coming soon</h3>
			<p>Tickets for Harmoni Expo – Autumn Fair, October 24–25 will be released soon.</p>
			<p>This year marks our 30th anniversary, with more details to be shared soon.</p>
		</div>
	</div>
)

export default ComingSoon
